<script setup>
import SummaryBases from './Items/SummaryBases.vue';
import SummaryPeriod from './Items/SummaryPeriod.vue';
import SummaryUsers from './Items/SummaryUsers.vue';
</script>

<template>
  <hr>
  <SummaryUsers/>
  <SummaryBases/>
  <SummaryPeriod/>
</template>
